

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import { computed, onMounted, ref, watch } from 'vue';
import { external } from '../apis/external';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { customer } from '../apis/customer';

import Button from 'primevue/button';
import IftaLabel from 'primevue/iftalabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import SelectButton from 'primevue/selectbutton';
import Divider from 'primevue/divider';
import { useToast } from 'primevue/usetoast';

export default {
	name: 'WalletUpdate',
	components: {
		Tabs,
		TabPanels,
		TabPanel,
		TabList,
		Tab,
		IftaLabel,
		InputText,
		Select,
		SelectButton,
		Button,
		Divider,
	},
	props: {
		tabs: {
			type: String,
			default: 'bank',
		},
	},
	setup(props) {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		const tabs = ref<string>(props.tabs)

		const formBankUpdate = ref({
			firstName: profile.value?.firstName ?? '',
			lastName: profile.value?.lastName ?? '',
			bankCode: profile.value?.customerBankName ?? '',
			bankNumber: profile.value?.customerBankAccount ?? '',
			autoPromotion: profile.value?.isAutoPromotion ?? false,
		});

		const formP2pUpdate = ref({
			uid: profile.value?.peer2PayUID ?? '',
			autoPromotion: profile.value?.isAutoPromotion ?? false,
		});

		const optionTabWalletUpdate = ref({
			bankCode: [],
			autoPromotion: [
				{ name: 'เปิด', value: true },
				{ name: 'ปิด', value: false },
			],
		});

		const isBankUpdated = computed(() => !!profile.value?.customerBankName && !!profile.value?.customerBankAccount);

		const isP2pUpdated = computed(() => !!profile.value?.peer2PayUID && profile.value.isSyncPeer2Pay);

		const handleUpdateBank = async (payload: any) => {
			try {
				const resp = await external.updateBank(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				await auth.fetchData();
				auth.hydrate();

				toast.add({ severity: 'info', summary: resp.message, detail: 'อัปเดตบัญชีธนาคารสำเร็จ', life: 3000 });
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			}
		};


		const handleBanksList = async () => {
			try {
				const resp = await external.bankList({ data: null });

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				optionTabWalletUpdate.value.bankCode = resp.result?.banks || [];
			} catch (error) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			}
		};

		const handleUpdatePeer2PayUID = async (payload: any) => {
			try {
				const resp = await customer.updatePeer2PayUID(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				await auth.fetchData();
				auth.hydrate();

				toast.add({ severity: 'info', summary: resp.message, detail: 'อัปเดตบัญชีธนาคารสำเร็จ', life: 3000 });
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			}
		};

		const validateBankUpdate = (): boolean => {
			if (formBankUpdate.value.firstName === '' || formBankUpdate.value.lastName === '' || formBankUpdate.value.bankCode === '') {
				return false;
			}

			formBankUpdate.value.bankNumber = formBankUpdate.value.bankNumber.replace(/-/g, '');
			return !(formBankUpdate.value.bankNumber === '' ||
				formBankUpdate.value.bankNumber.length > 20 ||
				!(/^\d+$/.test(formBankUpdate.value.bankNumber)));
		};

		const handleBankUpdateSubmit = async () => {
			if (!validateBankUpdate()) return;

			const payload = {
				bankName: formBankUpdate.value.bankCode,
				accountNo: formBankUpdate.value.bankNumber,
				firstName: formBankUpdate.value.firstName,
				lastName: formBankUpdate.value.lastName,
				middleName: '',
				isAutoPromotion: formBankUpdate.value.autoPromotion,
			};

			await handleUpdateBank(payload);
		};

		const handleP2pUpdateSubmit = async () => {
			if (
				formP2pUpdate.value.uid === '' ||
				formP2pUpdate.value.uid.length > 20 ||
				!/^\d+$/.test(formP2pUpdate.value.uid)
			) {
				return;
			}

			const payload = {
				peer2PayUID: formP2pUpdate.value.uid,
				isAutoPromotion: formP2pUpdate.value.autoPromotion,
			};
			await handleUpdatePeer2PayUID(payload);
		};

		watch(tabs, (value) => {
			if (value === 'bank') {
				if (isBankUpdated.value) return;
				handleBanksList();
			}
		});

		onMounted(() => {
			handleBanksList();
		})

		return {
			tabs,
			formBankUpdate,
			formP2pUpdate,
			optionTabWalletUpdate,
			isBankUpdated,
			isP2pUpdated,
			handleBankUpdateSubmit,
			handleP2pUpdateSubmit,
		}
	},
}

